<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button parkourBackButton />
    </ion-buttons>

    <ion-title>Team</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher [parkourRefresh]="onPageRefresh" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <parkour-page-layout>
    <!-- TODO: UX Copy team aan JSON toevoegen -->
    <ng-container *parkourPageContent="mainPageData$ | async; refresh: onPageRefresh; let data">
      <parkour-page-with-hero
        [heroImage]="of(data.teamlidContext) | profielFotoOfJongere | async"
        title="Team"
      >
        <div class="space-y-6 container-1-col">
          <ul class="space-y-2">
            <li>
              <parkour-action [link]="'./details/eigenaar'">
                <div
                  class="flex p-4 justify-between items-center rounded bg-n-200 hover:bg-n-300 transition-colors"
                >
                  <div class="flex items-start gap-x-3">
                    <parkour-profiel-foto-badge
                      [alt]="false"
                      [profiel]="data.teamlidContext.jongereProfiel"
                      [size]="'3'"
                    ></parkour-profiel-foto-badge>

                    <div class="flex flex-col items-start gap-y-2 whitespace-normal">
                      <div class="flex flex-col items-start gap-y-1 whitespace-normal">
                        <p class="typo-body variant-body-fat">
                          {{ data.teamlidContext.jongereProfiel | profielnaam }}
                        </p>

                        <span class="typo-body flex align-center gap-x-1 text-s-200">
                          Teameigenaar
                        </span>
                      </div>
                    </div>
                  </div>
                  <parkour-icon class="text-n-600" name="chevron-right" size="3" />
                </div>
              </parkour-action>
            </li>

            @for (teamlid of data.teamleden; track $index) {
              <li>
                <parkour-teammember-action [link]="'./details/' + teamlid.id" [teamlid]="teamlid" />
              </li>
            }
          </ul>

          <parkour-team-verlaten-section
            [jongere]="data.teamlidContext.jongereProfiel"
            [teamlidProfielId]="data.user.profielId"
            class="block container-1-col"
          />
        </div>
      </parkour-page-with-hero>
    </ng-container>
  </parkour-page-layout>
</ion-content>
